import axios from "axios";
import { store } from "../store";
import { setAlertAction, setLoadingOffAction, setLoadingOnAction } from "../reducers";
import { PORTAL_CODE } from "./constants";
import { _getSessionToken, clearSession } from "./utils";
import { checkSessionService } from "../api";

const loginOptions = () => {
  const tenant = store?.getState().tenant;

  const requestHeaders = {
    "Masbran-Tenant-Code": tenant,
  };

  return { headers: requestHeaders };
};

const getOptions = (config, headers) => {
  const tenant = localStorage.getItem("masbranSelectedTenant");
  const sessionToken = _getSessionToken();

  const requestHeaders = {
    "Masbran-Session-Token": sessionToken,
    "Masbran-Client-App-Id": PORTAL_CODE,
    "Masbran-Tenant-Code": tenant,
    "Masbran-Page-Context": "",
  };

  const options = { headers: requestHeaders, ...config };

  if (headers) {
    const keys = Object.keys(headers);
    keys.forEach((key) => (options.headers[key] = headers[key]));
  }
  return options;
};

const resolvePromise = (response, loading, responseThen, message, showMessage = true) => {
  const responseCode = parseInt(response.headers["masbran-result-code"]);

  if (loading) {
    store.dispatch(setLoadingOffAction());
  }

  showMessage && store.dispatch(setAlertAction(false, true, responseCode, message));

  if (responseThen) {
    responseThen(response.data);
  }
};

const rejectPromise = (error, loading, responseCatch) => {
  const errorCode = error?.response?.data?.errorCode;
  const statusCode = error?.response?.status;
  const message = error?.response?.data?.userMessage;

  if (loading) store.dispatch(setLoadingOffAction());

  if (statusCode === 403) checkSessionService();

  if (statusCode === 401) clearSession();

  store.dispatch(setAlertAction(true, false, errorCode, null, message));

  if (responseCatch) responseCatch(error);
};

export const put = (url, data, config, loading = true, responseThen, responseCatch, headers, message) => {
  if (loading) {
    store.dispatch(setLoadingOnAction());
  }
  axios
    .put(url, data, getOptions(config, headers))
    .then((response) => {
      resolvePromise(response, loading, responseThen, message);
    })
    .catch((error) => rejectPromise(error, loading, responseCatch));
};

export const post = (
  url,
  data,
  config,
  loading = true,
  responseThen = undefined,
  responseCatch = undefined,
  headers,
  message,
  login = false,
  showMessage = true,
) => {
  if (loading) {
    store.dispatch(setLoadingOnAction());
  }
  const options = login ? loginOptions() : getOptions(config, headers);
  axios
    .post(url, data, options)
    .then((response) => resolvePromise(response, loading, responseThen, message, showMessage))
    .catch((error) => rejectPromise(error, loading, responseCatch));
};

export const patch = (
  url,
  data,
  config,
  loading = true,
  responseThen = undefined,
  responseCatch = undefined,
  headers,
  message,
) => {
  if (loading) {
    store.dispatch(setLoadingOnAction());
  }
  axios
    .patch(url, data, getOptions(config, headers))
    .then((response) => resolvePromise(response, loading, responseThen, message))
    .catch((error) => rejectPromise(error, loading, responseCatch));
};

export const get = (url, config, loading = true, responseThen, responseCatch, headers, message) => {
  if (loading) {
    store.dispatch(setLoadingOnAction());
  }
  axios
    .get(url, getOptions(config, headers))
    .then((response) => resolvePromise(response, loading, responseThen, message, false))
    .catch((error) => rejectPromise(error, loading, responseCatch));
};

export const deleteRequest = (
  url,
  config,
  loading = true,
  responseThen = undefined,
  responseCatch = undefined,
  headers,
  message,
) => {
  if (loading) {
    store.dispatch(setLoadingOnAction());
  }
  axios
    .delete(url, getOptions(config, headers))
    .then((response) => resolvePromise(response, loading, responseThen, message))
    .catch((error) => rejectPromise(error, loading, responseCatch));
};

export const buildUrl = (url, variables) =>
  url.replace(/:(\w+)/g, (match, p1) => (p1 in variables ? variables[p1] : match));
